export const REQUEST_CANCELLATION_INDEX = 0;
export const CONFIRM_CANCELLATION_INDEX = 1;

export const cancellationSteps = ['Solicitar cancelamento', 'Confirmar cancelamento'];
